export enum AssessmentPhase {
    WINERY_SUBMISSION = 'winerySubmission',
    INSPECTION = 'inspection',
    CHECK = 'check',
}
